module.exports = __webpack_public_path__ + "img/12_responsible_consumption_and_production.7e66db90.svg";